import * as React from 'react';
import { Layout } from 'react-admin';
import AppMenu from './AppMenu';
import AppBarWithSearch from './AppBarWithSearch';

export default function AppLayout(props) {
    return <Layout {...props} menu={AppMenu} appBar={AppBarWithSearch} />;
}
